(function($){
  'use strict';

  function getVariants(){
    var el=document.getElementById('MiskProductVariants');
    if(!el) return [];
    try{return JSON.parse(el.textContent||el.innerText||'[]');}catch(e){return [];}
  }

  function selectedValues(){
    var vals=[];
    $('.swatch').each(function(){
      var idx=parseInt($(this).attr('data-option-index'),10);
      var checked=$(this).find('input[type=radio]:checked').val();
      if(!isNaN(idx)) vals[idx]=checked;
    });
    return vals;
  }

  function exactVariant(variants,vals){
    return variants.find(function(v){
      if(!v.available) return false;
      for(var i=0;i<vals.length;i++){
        if(vals[i]!==undefined && v.options[i]!==vals[i]) return false;
      }
      return true;
    });
  }

  function quantityCap(v){
    if(!v) return 1;
    if(!v.inventory_management || v.inventory_policy==='continue') return 9999;
    return Math.max(parseInt(v.inventory_quantity||0,10),1);
  }

  function syncSelectorsToVariant(v){
    if(!v) return;
    v.options.forEach(function(val,idx){
      var $radio=$('.swatch[data-option-index="'+idx+'"] input[type=radio]').filter(function(){return $(this).val()===val;}).first();
      if($radio.length) $radio.prop('checked',true);
      var $selector=$('.single-option-selector').eq(idx);
      if($selector.length && $selector.val()!==val) $selector.val(val).trigger('change');
    });
    if($('#productSelect').val()!==String(v.id)) $('#productSelect').val(String(v.id)).trigger('change');
  }

  function updateAvailability(){
    var variants=getVariants();
    if(!variants.length) return;
    var vals=selectedValues();
    $('.swatch').each(function(){
      var idx=parseInt($(this).attr('data-option-index'),10);
      $(this).find('input[type=radio]').each(function(){
        var value=$(this).val();
        var possible=variants.some(function(v){
          if(!v.available || v.options[idx]!==value) return false;
          for(var j=0;j<vals.length;j++){
            if(j===idx || vals[j]===undefined) continue;
            if(v.options[j]!==vals[j]) return false;
          }
          return true;
        });
        $(this).prop('disabled',!possible)
          .closest('.swatch-element')
          .toggleClass('soldout',!possible)
          .toggleClass('available',possible)
          .attr('aria-disabled',possible?'false':'true');
      });
    });
  }

  function syncSticky(v){
    var variants=getVariants();
    if(!v){
      var id=$('#productSelect').val();
      v=variants.find(function(x){return String(x.id)===String(id);});
    }
    if(!v) return;
    var cap=quantityCap(v);
    $('.pro_sticky_atc .sticky__pro_add_cart input[name=id]').val(v.id);
    $('.pro_sticky_atc .Pro_variant__active').attr('data-value',v.id).text(v.title);
    $('.pro_sticky_atc .pro_variant_swatch').removeClass('active').filter('[data-value="'+v.id+'"]').addClass('active');
    $('.sticky__qty input').attr('totalqty',cap);
    var cur=parseInt($('.sticky__qty input').val(),10)||1;
    $('.sticky__qty input').val(Math.max(1,Math.min(cur,cap)));
    if(v.featured_image && v.featured_image.src) $('.sticky_pro_img img').attr('src',v.featured_image.src);
    $('.pro_sticky_atc .sticky_pro__cart').prop('disabled',!v.available).toggleClass('disabled',!v.available);
  }

  function ensureValidSelection(changedIdx,changedValue){
    var variants=getVariants();
    if(!variants.length) return;
    var vals=selectedValues();
    var exact=exactVariant(variants,vals);
    if(exact){
      if($('#productSelect').val()!==String(exact.id)) $('#productSelect').val(String(exact.id)).trigger('change');
      updateAvailability();
      syncSticky(exact);
      return;
    }
    var fallback=variants.find(function(v){return v.available && v.options[changedIdx]===changedValue;}) || variants.find(function(v){return v.available;});
    if(fallback){syncSelectorsToVariant(fallback);syncSticky(fallback);}
    updateAvailability();
  }

  $(document).on('change','.swatch input[type=radio]',function(){
    var idx=parseInt($(this).closest('.swatch').attr('data-option-index'),10);
    var val=$(this).val();
    setTimeout(function(){ensureValidSelection(idx,val);},0);
  });

  $(document).on('change','.single-option-selector,#productSelect',function(){
    setTimeout(function(){updateAvailability();syncSticky();},0);
  });

  $(document).on('click','.pro_variant_swatch:not(.sold-out)',function(e){
    e.preventDefault();
    var variants=getVariants();
    var id=String($(this).data('value'));
    var v=variants.find(function(x){return String(x.id)===id && x.available;});
    if(v){syncSelectorsToVariant(v);syncSticky(v);updateAvailability();}
  });

  $(document).on('click','.qtybutton',function(){
    var $input=$(this).parent().find('input');
    setTimeout(function(){
      var n=parseInt($input.val(),10)||1;
      if(n<1) $input.val(1);
    },0);
  });

  $(document).on('click','.quantity_inner .dec_btn,.quantity_inner .inc_btn',function(){
    setTimeout(function(){
      $('.quantity_inner input').each(function(){
        var min=1,max=parseInt($(this).attr('totalqty'),10)||9999,val=parseInt($(this).val(),10)||1;
        $(this).val(Math.max(min,Math.min(val,max)));
      });
    },0);
  });

  $(document).on('change blur','.cart-desktop-device input[name="updates[]"],.cart-mobile-device input[name="updates[]"]',function(){
    var n=parseInt($(this).val(),10)||1;
    if(n<1) $(this).val(1);
  });

  $(function(){
    var variants=getVariants();
    var selectedId=$('#productSelect').val();
    var initial=variants.find(function(v){return v.available && String(v.id)===String(selectedId);}) || variants.find(function(v){return v.available;});
    if(initial){syncSelectorsToVariant(initial);syncSticky(initial);}
    updateAvailability();
  });
})(jQuery);